import api from "@/services/api"

type SetSupervisorPinRequest = {
  pin: string
}

export const setSupervisorPin = async (
  request_body: SetSupervisorPinRequest
): Promise<void> => {
  await api.post("/onboarding/set-supervisor-pin", {
    body: request_body,
  })
}
